var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blue-bg"},[_c('breadcrumbs',{attrs:{"items":[
      { name: _vm.$t('Forgot password'), link: '/forgot-password' },
      { name: _vm.$t('Sent'), link: '/forgot-password/sent' },
    ]}}),_vm._v(" "),_c('section',[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.$t("Forgot password sent"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-center"},[_c('div',{staticClass:"sign-box"},[_c('p',{staticClass:"text-center"},[_vm._v("\n            "+_vm._s(_vm.$t(
                "An email with reset instructions has been sent. Please check your email and login in again",
              ))+"\n          ")])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }